import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleChangeFounderDocumentFileInput, handleSubmitDocumentCreateSubmit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $form, $view } from 'signals/global.signals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { useState } from 'react';

const FounderDocumentsUploadModal = () => {
  const [isFileUpload, setIsFileUpload] = useState(true);
  const [isUploading, setIsUploading] = useState(false);

  const renderFileUploadSection = () => {
    if ($form.value.attachments?.length > 0) {
      return (
        <div className="d-flex align-items-center">
          <Button
            variant="transparent"
            className="p-0 text-danger"
            onClick={() => {
              $form.update({
                attachments: [],
                file: null, // Clear file too
              });
              setIsUploading(false);
            }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <span className="ms-16 text-white">
            {($form.value.attachments && $form.value.attachments[0].name)}
          </span>
          {isUploading && <span className="ms-8 text-warning">Uploading...</span>}
        </div>
      );
    }

    // If file selected but not uploaded yet
    if ($form.value.file && !$form.value.attachments?.length) {
      return (
        <div className="d-flex align-items-center">
          <span className="text-warning">📤 Uploading {$form.value.file.name}...</span>
          <Button
            variant="transparent"
            className="p-0 text-danger ms-16"
            onClick={() => {
              $form.update({
                file: null,
              });
              setIsUploading(false);
            }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </div>
      );
    }

    return (
      <UniversalInput
        label="Select File..."
        name="file"
        type="file"
        className="border rounded-pill w-100 text-start ps-16 py-8"
        customOnChange={async (e) => {
          if (e.target.files[0]) {
            setIsUploading(true);
            try {
              await handleChangeFounderDocumentFileInput(e);
              $form.update({
                file: e.target.files[0],
              });
            } catch (error) {
              console.error('File upload error:', error);
              // You can add toast notification here if you have one
              // showToast('Error uploading file. Please try again.', 'error');
            } finally {
              setIsUploading(false);
            }
          }
        }}
      />
    );
  };

  // Check if submit should be disabled
  const isSubmitDisabled = () => {
    if (isFileUpload) {
      // For file upload: disable if file is selected but not uploaded yet, or if currently uploading
      return isUploading || ($form.value.file && !$form.value.attachments?.length);
    }
    // For URL: need URL entered
    return !$form.value.fileUrl;
  };

  return (
    <SimpleModal
      show={$view.value.activeModal === 'founder-document-upload'}
      isLoading={$view.value?.isModalLoading || isUploading}
      title="Upload Document"
      onHide={handleHideModal}
      onPrimaryClick={isSubmitDisabled() ? null : handleSubmitDocumentCreateSubmit}
      primaryButtonText="Save/Upload"
      primaryButtonVariant={isSubmitDisabled() ? 'secondary' : 'primary'}
      secondaryButtonText="Cancel"
      onSecondaryClick={handleHideModal}
      size="lg"
    >
      <UniversalInput
        label="File Description"
        name="name"
        type="text"
        placeholder="Enter name"
        className="mb-16"
      />
      <UniversalInput
        label="Folder"
        name="folder"
        type="select"
        options={$view.value?.folderOptions || []}
        className="mb-16"
        isCreatable
        required={true}
      />
      <div className="mb-16 d-flex justify-content-start align-items-center">
        <Button
          variant="transparent"
          className={`me-2 ${isFileUpload ? 'fw-bold text-primary' : 'text-white'}`}
          onClick={() => setIsFileUpload(true)}
        >
          File
        </Button>
        <span className="text-white mx-2">|</span>
        <Button
          variant="transparent"
          className={`ms-2 ${!isFileUpload ? 'fw-bold text-primary' : 'text-white'}`}
          onClick={() => setIsFileUpload(false)}
        >
          URL
        </Button>
      </div>

      {isFileUpload ?
        renderFileUploadSection() : (
          <UniversalInput
            label="Document URL"
            name="fileUrl"
            type="text"
            placeholder="Enter document URL"
            className="mb-16"
            customOnChange={(e) => {
              $form.update({
                fileUrl: e.target.value,
              });
            }}
          />
        )}
    </SimpleModal>
  );
};

export default FounderDocumentsUploadModal;